import React from 'react';
import PropTypes from 'prop-types';
import styles from './Button.module.scss';
import classNames from 'classnames';

const Button = ({
    children = '',
    link,
    href,
    label = '',
    text = '',
    title = '',
    target = null,
    onClick = () => {},
    icon = '',
    type = '',
    subType = '',
    className = '',
    minWidth = null,
    isDownload = false,
    disabled = false,
    untranslatedModifiers = [],
    attrs = {},
    html = '',
}) => {
    const linkHref = href || link || undefined;
    const isButton = !linkHref;
    const Tag = !isButton ? 'a' : 'button';

    const arrowIcon =
        !icon && (type === 'Primary' || type === 'PrimarySmall' || type === 'Secondary' || type === 'SecondarySmall')
            ? 'ArrowBlue'
            : '';
    const iconModifier = icon || arrowIcon;

    const props = {
        ...(!isButton && { href: linkHref }),
        ...(target && { target: target }),
        ...(onClick && { onClick: onClick }),
        ...(label && { ['aria-label']: label }),
        ...(isDownload && { download: true }),
        ...(disabled && { disabled: true }),
    };

    const classes = classNames(
        styles['Button'],
        {
            [styles['Button--Link']]: linkHref && !type,
            [styles[`Button--${type}`]]: type,
            [styles[`Button--${subType}`]]: subType,
            [styles['Button--HasIcon']]: !!iconModifier,
            [styles['Button--HasArrowIcon']]: !!arrowIcon,
        },
        untranslatedModifiers.map((x) => styles[x]),
        className
    );

    const iconClasses = classNames(styles['Button__Icon'], styles[`Button__Icon--${iconModifier}`], 'icon');

    const minWidthStyle = minWidth ? { minWidth } : {};

    return (
        <Tag {...props} {...attrs} style={minWidthStyle} className={classes}>
            {text || title || children}
            {html && <span dangerouslySetInnerHTML={{ __html: html }} />}
            {!!iconModifier && <span className={iconClasses} aria-hidden={true} />}
        </Tag>
    );
};

Button.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    link: PropTypes.string,
    href: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
    target: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.string,
    type: PropTypes.string,
    subType: PropTypes.string,
    className: PropTypes.string,
    minWidth: PropTypes.string,
    isDownload: PropTypes.bool,
    disabled: PropTypes.bool,
    untranslatedModifiers: PropTypes.arrayOf(PropTypes.string),
    attrs: PropTypes.object,
    html: PropTypes.string,
};

export default Button;
